export function cpfFormatter(rawCpf: string): string {
  return rawCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function zipCodeFormatter(rawZipCode: string): string {
  return rawZipCode.replace(/(\d{5})(\d{3})/, '$1-$2');
}

export function cellPhoneFormatter(rawCellPhone: string): string {
  return rawCellPhone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
}

export function currencyFormatter(value: number): string {
  const options = { style: 'currency', currency: 'BRL' };
  return value.toLocaleString('pt-BR', options);
}

export function currencyToNumberFormatter(currency: string): number {
  const currencyWithoutSymbols = currency.replaceAll(/\D/g, '');
  return +currencyWithoutSymbols / 100;
}
